export enum VTO_EVENTS {
    ALL_SHADES_VIEWED = 'allShadesViewed',
    BEST_SHADES_VIEWED = 'bestShadesViewed',
    CAMERA_CLOSED = 'cameraClosed',
    CAMERA_FAILED = 'cameraFailed',
    CAMERA_OPENED = 'cameraOpened',
    CLOSED = 'closed',
    COMPARE = 'compare',
    COMPARE_DISABLED = 'compareDisabled',
    CTA = 'cta',
    ENGINE_CLOSED = 'engineClosed',
    FOUNDATION_QR_CODE_OVERLAY_CLOSED = 'foundationQrCodeOverlayClosed',
    FOUNDATION_QR_CODE_OVERLAY_OPENED = 'foundationQrCodeOverlayOpened',
    KISS_DETECTED = 'kissDetected',
    LOADED = 'loaded',
    LOADING = 'loading',
    MATCH_PERSONALIZED = 'myMatchPersonalized',
    MATCH_REMOVED = 'myMatchRemoved',
    MATCH_SAVED = 'myMatchSaved',
    NON_SHOPPABLE_PRODUCTS_LOADED = 'nonShoppableProductsLoaded',
    OPENED = 'opened',
    PAIR_SHADE_GRID_OPENED = 'pairShadeGridOpened',
    PAIR_SHADE_SELECTED = 'pairShadeSelected',
    PHOTO_LOADED = 'photoLoaded',
    PHOTO_SAVED = 'photoSaved',
    PRICE_SUPPRESSED = 'priceSuppressed',
    RESET = 'reset',
    SHADE_FINDER_CANCELLED = 'shadeFinderCancelled',
    SHADE_FINDER_COMPLETED = 'shadeFinderCompleted',
    SHADE_FINDER_STARTED = 'shadeFinderStared',
    SHADE_REMINDER_OVERLAY_CLOSED = 'shadeReminderOverlayClosed',
    SHADE_REMINDER_OVERLAY_KEEP = 'shadeReminderOverlayKeep',
    SHADE_REMINDER_OVERLAY_OPENED = 'shadeReminderOverlayOpened',
    SHADE_REMINDER_OVERLAY_RETAKE = 'shadeReminderOverlayRetake',
    SHOPPABLE_PRODUCTS_LOADED = 'shoppableProductsLoaded',
    SKIN_ANALYSIS_FINISHED = 'skinAnalysisFinished',
    SKIN_ANALYSIS_STARTED = 'skinAnalysisStarted',
    SKIN_BACK_TO_DETECTING = 'skinBackToDetecting',
    SKIN_SHADE_FOUND = 'skinShadeFound',
    SPLIT_FOUR_WAY = 'splitFourWay',
    SPLIT_FOUR_WAY_DISABLED = 'splitFourWayDisabled',
    SURVEY_IGNORED = 'surveyIgnored',
    SURVEY_LOADED = 'surveyLoaded',
    SURVEY_SUBMITTED = 'surveySubmitted',
    VIDEO_LOADED = 'videoLoaded',
    ZOOM = 'zoom',
    TUTORIAL_STARTED = 'tutorialStarted',
    TUTORIAL_UNMUTED = 'tutorialUnmuted',
    TUTORIAL_MUTED = 'tutorialMuted',
    TUTORIAL_PAUSED = 'tutorialPaused',
    TUTORIAL_STOPPED = 'tutorialStopped',
    TUTORIAL_RESUMED = 'tutorialResumed',
    TUTORIAL_PLAY_SPEED_UPDATED = 'tutorialPlaySpeedUpdated',
    TUTORIAL_PREVIOUS_STEP = 'tutorialPreviousStep',
    TUTORIAL_NEXT_STEP = 'tutorialNextStep',
    TUTORIAL_LOOK_SELECTED = 'applyLook',
    TUTORIAL_PRODUCT_LIST_CLICKED = 'productListClicked',
    TUTORIAL_PRODUCTS_USED_ITEM_CLICKED = 'productsUsedItemClicked',
    BROW_FACE_ATTRIBUTE_PREDICTION_STARTED = 'faceAttributePredictionStarted',
    BROW_FACE_ATTRIBUTE_UPDATED = 'faceAttributeUpdated',
    BROW_GOAL_SELECTED = 'browGoalSelected',
    BROW_TIPS_CLICKED = 'tipsClicked',
    BROW_BACK_TO_GOALS_CLICKED = 'backToGoalsClicked',
    BROW_SHAPE_CHANGED = 'shapeChanged',
    BROW_SHADE_TRY_ON = 'browShadeTryOn',
    BROW_LENGTH_CHANGED = 'lengthChanged',
    BROW_THICKNESS_CHANGED = 'thicknessChanged',
    BROW_OPACITY_CHANGED = 'opacityChanged',
    BROW_GOLDEN_RATION_ENABLED = 'goldenRatioEnabled',
    BROW_GOLDEN_RATION_DISABLED = 'goldenRatioDisabled',
    BROW_STENCIL_ENABLED = 'stencilEnabled',
    BROW_STENCIL_DISABLED = 'stencilDisabled',
    BROW_COMPARE_ENABLED = 'compareEnabled',
    BROW_CAPTURE_CLICKED = 'captureClicked',
    BROW_SEE_ALL_SHADES_CLICKED = 'seeAllShadesClicked',
    BROW_GET_BROW_CLICKED = 'getBrowClicked'
}
